var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 64,
    viewBox: "0 0 171 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nrdeal 22b 1",
    clipPath: "url(#clip0_250_257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.64648 63.1533L3.11523 60.9658C3.05273 60.9775 2.95898 60.9814 2.83398 60.9814H1.14648V63.1533H-0.244141V55.6846H2.83398C3.47852 55.6846 4.04102 55.7939 4.52148 56.0127C4.99805 56.2236 5.36523 56.5244 5.61523 56.9189C5.87305 57.3174 6.00586 57.79 6.00586 58.3408C6.00586 58.9033 5.86914 59.3877 5.59961 59.7939C5.32617 60.2002 4.93555 60.5049 4.42773 60.7002L6.14648 63.1533H4.64648ZM4.61523 58.3408C4.61523 57.8643 4.45898 57.4971 4.14648 57.2471C3.83398 56.9893 3.37305 56.8564 2.77148 56.8564H1.14648V59.8408H2.77148C3.37305 59.8408 3.83398 59.7119 4.14648 59.4502C4.45898 59.1924 4.61523 58.8213 4.61523 58.3408Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.2396 61.9971V63.1533H9.63019V55.6846H15.0833V56.8408H11.0208V58.7939H14.6302V59.9346H11.0208V61.9971H15.2396Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.4949 55.6846V63.1533H24.3542L20.2292 58.0908V63.1533H18.8542V55.6846H19.9949L24.1199 60.7471V55.6846H25.4949Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.1802 61.9971V63.1533H29.5708V55.6846H35.0239V56.8408H30.9614V58.7939H34.5708V59.9346H30.9614V61.9971H35.1802Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M49.7167 55.6846L47.2323 63.1533H45.7636L43.9198 57.6221L42.0448 63.1533H40.5605L38.0761 55.6846H39.5292L41.373 61.3564L43.3105 55.6846H44.5917L46.4823 61.3877L48.3886 55.6846H49.7167Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M57.9158 61.4189H54.1815L53.4471 63.1533H52.0252L55.3846 55.6846H56.744L60.119 63.1533H58.6658L57.9158 61.4189ZM57.4627 60.3408L56.0565 57.0752L54.6502 60.3408H57.4627Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M68.4352 59.2627C68.8492 59.3994 69.1774 59.6299 69.4196 59.9502C69.6578 60.2627 69.7789 60.6533 69.7789 61.1221C69.7789 61.7705 69.5289 62.2705 69.0289 62.6221C68.5289 62.9775 67.8024 63.1533 66.8571 63.1533H63.1383V55.6846H66.6383C67.5211 55.6846 68.2008 55.8564 68.6696 56.2002C69.1461 56.5439 69.3883 57.0205 69.3883 57.6221C69.3883 57.9971 69.3024 58.3252 69.1383 58.6064C68.9703 58.8877 68.736 59.1064 68.4352 59.2627ZM64.5289 56.7783V58.8252H66.4977C66.9742 58.8252 67.3453 58.7432 67.6071 58.5752C67.8649 58.3994 67.9977 58.1455 67.9977 57.8096C67.9977 57.4658 67.8649 57.2119 67.6071 57.0439C67.3453 56.8682 66.9742 56.7783 66.4977 56.7783H64.5289ZM66.7633 62.0596C67.8453 62.0596 68.3883 61.7002 68.3883 60.9814C68.3883 60.2627 67.8453 59.9033 66.7633 59.9033H64.5289V62.0596H66.7633Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M73.3325 55.6846H74.7231V61.9814H78.6294V63.1533H73.3325V55.6846Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M87.409 61.9971V63.1533H81.7996V55.6846H87.2527V56.8408H83.1902V58.7939H86.7996V59.9346H83.1902V61.9971H87.409Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M99.1254 55.6846C99.77 55.6846 100.332 55.7939 100.813 56.0127C101.289 56.2236 101.657 56.5244 101.907 56.9189C102.164 57.3174 102.297 57.79 102.297 58.3408C102.297 58.8838 102.164 59.3564 101.907 59.7627C101.657 60.1611 101.289 60.4658 100.813 60.6846C100.332 60.8955 99.77 60.9971 99.1254 60.9971H97.4379V63.1533H96.0473V55.6846H99.1254ZM99.0629 59.8252C99.6645 59.8252 100.125 59.7002 100.438 59.4502C100.75 59.1924 100.907 58.8213 100.907 58.3408C100.907 57.8643 100.75 57.4971 100.438 57.2471C100.125 56.9893 99.6645 56.8564 99.0629 56.8564H97.4379V59.8252H99.0629Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M105.868 55.6846H107.259V61.9814H111.165V63.1533H105.868V55.6846Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M119.179 61.4189H115.445L114.71 63.1533H113.289L116.648 55.6846H118.007L121.382 63.1533H119.929L119.179 61.4189ZM118.726 60.3408L117.32 57.0752L115.914 60.3408H118.726Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M125.917 56.8564H123.449V55.6846H129.777V56.8564H127.308V63.1533H125.917V56.8564Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M134.291 56.8408V59.1221H137.901V60.2939H134.291V63.1533H132.901V55.6846H138.354V56.8408H134.291Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M145.273 63.2627C144.5 63.2627 143.808 63.0986 143.195 62.7627C142.589 62.4307 142.109 61.9736 141.757 61.3877C141.414 60.8057 141.242 60.1494 141.242 59.4189C141.242 58.6924 141.414 58.0361 141.757 57.4502C142.109 56.8682 142.589 56.4111 143.195 56.0752C143.808 55.7432 144.5 55.5752 145.273 55.5752C146.031 55.5752 146.714 55.7432 147.32 56.0752C147.933 56.4111 148.414 56.8682 148.757 57.4502C149.109 58.0361 149.289 58.6924 149.289 59.4189C149.289 60.1494 149.109 60.8057 148.757 61.3877C148.414 61.9736 147.933 62.4307 147.32 62.7627C146.714 63.0986 146.031 63.2627 145.273 63.2627ZM145.273 62.0439C145.761 62.0439 146.203 61.9346 146.601 61.7158C147.007 61.4893 147.324 61.1768 147.554 60.7783C147.781 60.3721 147.898 59.9189 147.898 59.4189C147.898 58.9189 147.781 58.4736 147.554 58.0752C147.324 57.6689 147.007 57.3564 146.601 57.1377C146.203 56.9111 145.761 56.7939 145.273 56.7939C144.773 56.7939 144.32 56.9111 143.914 57.1377C143.515 57.3564 143.203 57.6689 142.976 58.0752C142.757 58.4736 142.648 58.9189 142.648 59.4189C142.648 59.9189 142.757 60.3721 142.976 60.7783C143.203 61.1768 143.515 61.4893 143.914 61.7158C144.32 61.9346 144.773 62.0439 145.273 62.0439Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M157.721 63.1533L156.19 60.9658C156.128 60.9775 156.034 60.9814 155.909 60.9814H154.221V63.1533H152.831V55.6846H155.909C156.553 55.6846 157.116 55.7939 157.596 56.0127C158.073 56.2236 158.44 56.5244 158.69 56.9189C158.948 57.3174 159.081 57.79 159.081 58.3408C159.081 58.9033 158.944 59.3877 158.674 59.7939C158.401 60.2002 158.01 60.5049 157.503 60.7002L159.221 63.1533H157.721ZM157.69 58.3408C157.69 57.8643 157.534 57.4971 157.221 57.2471C156.909 56.9893 156.448 56.8564 155.846 56.8564H154.221V59.8408H155.846C156.448 59.8408 156.909 59.7119 157.221 59.4502C157.534 59.1924 157.69 58.8213 157.69 58.3408Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M169.564 63.1533V58.2002L167.111 62.2939H166.486L164.033 58.2627V63.1533H162.705V55.6846H163.846L166.814 60.6377L169.736 55.6846H170.877V63.1533H169.564Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M27.5482 7.3252H35.97V45.8408H27.2357L8.36066 20.2939V45.8408H-0.123718V7.3252H8.61066L27.5482 32.8096V7.3252Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M56.5926 19.6357C56.9754 19.6357 57.3504 19.6592 57.7176 19.6982C58.0809 19.7412 58.4129 19.8037 58.7176 19.8857V27.1514C58.4129 27.0576 58.0613 26.9912 57.6551 26.9482C57.2488 26.9092 56.8113 26.8857 56.3426 26.8857C54.3309 26.8857 52.6707 27.4639 51.3582 28.6201C50.0535 29.7764 49.4051 31.4287 49.4051 33.5732V45.8389H41.1863V20.1357H49.4051V23.6826C50.2567 22.4326 51.2957 21.4482 52.5145 20.7295C53.7332 20.0029 55.0926 19.6357 56.5926 19.6357Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M81.452 1.12402H89.6082V45.0928L81.452 45.1553V42.8428C80.5145 43.6982 79.4363 44.374 78.2176 44.874C76.9988 45.3623 75.6395 45.6084 74.1395 45.6084C71.784 45.6084 69.6434 45.0107 67.7176 43.8115C65.7879 42.6162 64.2567 41.0107 63.1238 38.999C61.9871 36.9912 61.4207 34.7412 61.4207 32.249C61.4207 29.7725 61.9871 27.5264 63.1238 25.5146C64.2567 23.5068 65.7879 21.9014 67.7176 20.7021C69.6434 19.5068 71.784 18.9053 74.1395 18.9053C75.6395 18.9053 76.9988 19.1514 78.2176 19.6396C79.4363 20.1318 80.5145 20.8037 81.452 21.6553V1.12402ZM75.7488 38.3584C77.4129 38.3584 78.8465 37.7725 80.0457 36.5928C81.241 35.417 81.8426 33.9678 81.8426 32.249C81.8426 30.542 81.241 29.1006 80.0457 27.9209C78.8465 26.7451 77.4129 26.1553 75.7488 26.1553C74.0301 26.1553 72.5809 26.7451 71.4051 27.9209C70.2254 29.1006 69.6395 30.542 69.6395 32.249C69.6395 33.9678 70.2254 35.417 71.4051 36.5928C72.5809 37.7725 74.0301 38.3584 75.7488 38.3584Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M162.656 45.8408V1.87207H170.875V45.8408H162.656Z",
    fill: "#22CD94"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M121.879 31.999V33.4053H102.223C102.387 35.249 102.961 36.6982 103.941 37.749C104.93 38.792 106.348 39.3115 108.191 39.3115C111.012 39.3115 112.808 38.2256 113.582 36.0459H121.488C120.851 38.8271 119.387 41.0889 117.098 42.8271C114.805 44.5576 111.879 45.4209 108.316 45.4209C105.449 45.4209 102.933 44.8662 100.769 43.749C98.6132 42.6357 96.9296 41.0732 95.7225 39.0615C94.5233 37.0537 93.9257 34.7178 93.9257 32.0615C93.9257 29.3662 94.5233 27.0107 95.7225 24.999C96.9296 22.9795 98.6014 21.4131 100.738 20.2959C102.883 19.1826 105.324 18.624 108.066 18.624C110.848 18.624 113.262 19.1826 115.316 20.2959C117.379 21.4131 118.988 22.9678 120.144 24.9678C121.301 26.96 121.879 29.3037 121.879 31.999ZM108.191 24.9209C106.73 24.9209 105.566 25.2334 104.691 25.8584C103.816 26.4834 103.164 27.3545 102.738 28.4678H113.394C112.965 27.3545 112.336 26.4834 111.504 25.8584C110.668 25.2334 109.566 24.9209 108.191 24.9209Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M156.456 38.2178H157.613V44.9053C157.308 45.0303 156.976 45.1436 156.613 45.249C156.257 45.3623 155.863 45.4209 155.425 45.4209C153.714 45.4209 152.175 45.0225 150.8 44.2334C149.433 43.4443 148.347 42.3818 147.535 41.0459C146.503 42.3818 145.245 43.4443 143.769 44.2334C142.288 45.0225 140.605 45.4209 138.722 45.4209C136.367 45.4209 134.226 44.8232 132.3 43.624C130.37 42.4287 128.839 40.8232 127.706 38.8115C126.57 36.792 126.003 34.542 126.003 32.0615C126.003 29.5732 126.57 27.3232 127.706 25.3115C128.839 23.3037 130.37 21.6982 132.3 20.499C134.226 19.3037 136.367 18.7021 138.722 18.7021C140.222 18.7021 141.581 18.9482 142.8 19.4365C144.027 19.9287 145.113 20.6006 146.05 21.4521V19.2021H154.206V35.7178C154.206 36.792 154.441 37.4795 154.91 37.7803C155.386 38.0732 155.902 38.2178 156.456 38.2178ZM140.331 38.1553C142.007 38.1553 143.445 37.5693 144.644 36.3896C145.839 35.2139 146.441 33.7725 146.441 32.0615C146.441 30.3428 145.839 28.8975 144.644 27.7178C143.445 26.542 142.007 25.9521 140.331 25.9521C138.62 25.9521 137.179 26.542 136.003 27.7178C134.824 28.8975 134.238 30.3428 134.238 32.0615C134.238 33.7725 134.824 35.2139 136.003 36.3896C137.179 37.5693 138.62 38.1553 140.331 38.1553Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_250_257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 63,
    fill: "white",
    transform: "translate(-1 0.339844)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.1416b3cefbcf8bc7dc26bab2b7b26cd3.svg";
export { ForwardRef as ReactComponent };